import styled from 'styled-components';
import { default as C } from '@assets/themes/colors';
import { default as D } from '@assets/themes/dimensions';

interface IBarContainerProps {
  height?: number;
};

export const RotateIconInit = styled.div`
  transition: transform 0.4s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`

export const Root = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
`

export const BarContainer = styled.div`
  width: 100%;
  height: ${(props: IBarContainerProps) => props.height ? `calc(${props.height}px - 42px)` : `calc(${D.MAIN_APP_BAR_HEIGHT}px - 34px)`};
  background-image: linear-gradient(45deg, ${C.LIGHT_ORANGE}, ${C.ORANGE});
  display: flex;
  padding: 42px 0 0 0; 
  transition: height 0.4s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
`

export const ArrowIconContainer = styled.div`
  z-index: 110;
  height: 40px;
  width: 40px;
  margin: 0 22px 0 34px;
`

export const TitleContainer = styled.div`
  font-family: 'Roboto';
  font-size: 34px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
`